function Footer() {


    return (
        <div className="wrapper">
            <p className="footer">Created at <a href="https://junocollege.com/" target="_blank" rel="noreferrer">Juno College</a></p>
        </div>
    )
}

export default Footer;